module.exports = __webpack_public_path__ + "static/media/pasta.f7932325.png";